// extracted by mini-css-extract-plugin
module.exports = {"externalIcon":"LinkWrapper_externalIcon__aG1B9"};